import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, FileText, Calendar, Wallet, CheckCircle, Clock, Tag, Home, MapPin } from 'lucide-react';
import { MobileLayout } from '../../components/MobileLayout';
import { useScreenInit } from '../../useScreenInit.js';
import { getApartmentById } from './appartamentiData';
export function CmContrattoDettaglioPage() {
  useScreenInit();
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const apartment = getApartmentById(id);
  if (!apartment || !apartment.contract) {
    return <MobileLayout data-id="element-1668">
        <div className="text-center py-20" data-id="element-1669">
          <p className="text-sm text-muted-foreground mb-4" data-id="element-1670">
            Contratto non trovato.
          </p>
          <Link to={apartment ? `/cm/clienti/appartamenti/${apartment.id}` : '/cm/clienti/appartamenti'} className="inline-flex items-center gap-1.5 text-sm font-medium text-coral hover:underline" data-id="element-1671">
            <ArrowLeft size={15} data-id="element-1672" />
            Torna all'appartamento
          </Link>
        </div>
      </MobileLayout>;
  }
  const contract = apartment.contract;
  const remaining = apartment.cleaningsTotal - apartment.cleaningsDone;
  const pct = apartment.cleaningsTotal > 0 ? Math.round(apartment.cleaningsDone / apartment.cleaningsTotal * 100) : 0;
  const totalEarnings = apartment.interventions.reduce((s, i) => s + i.earning, 0);
  const contractValue = contract.pricePerClean * apartment.cleaningsTotal;
  return <MobileLayout data-id="element-1673">
      {/* Back to apartment */}
      <Link to={`/cm/clienti/appartamenti/${apartment.id}`} className="inline-flex items-center gap-1.5 text-sm font-medium text-muted-foreground hover:text-navy transition-colors mb-4" data-id="element-1674">
        <ArrowLeft size={16} data-id="element-1675" />
        {apartment.name}
      </Link>

      {/* Header */}
      <div className="mb-6" data-id="element-1676">
        <div className="flex items-center gap-2 flex-wrap" data-id="element-1677">
          <h1 className="text-xl lg:text-2xl font-bold text-navy" data-id="element-1678">
            Dettaglio contratto
          </h1>
          <span className={`inline-flex items-center gap-1.5 text-[11px] font-semibold px-2.5 py-1 rounded-full border ${contract.active ? 'bg-emerald-50 text-emerald-700 border-emerald-200' : 'bg-gray-100 text-gray-500 border-gray-200'}`} data-id="element-1679">
            <CheckCircle size={12} data-id="element-1680" />
            {contract.active ? 'Attivo' : 'Scaduto'}
          </span>
        </div>
        <div className="flex items-center gap-1.5 text-sm text-muted-foreground mt-1" data-id="element-1681">
          <Home size={14} className="flex-shrink-0" data-id="element-1682" />
          <span data-id="element-1683">{apartment.name}</span>
          <span className="text-border" data-id="element-1684">·</span>
          <MapPin size={13} className="flex-shrink-0" data-id="element-1685" />
          <span className="truncate" data-id="element-1686">{apartment.address}</span>
        </div>
      </div>

      {/* Contract terms */}
      <div className="bg-white border border-border rounded-xl p-4 lg:p-5 mb-6" data-id="element-1687">
        <div className="flex items-center gap-2 mb-4" data-id="element-1688">
          <FileText size={16} className="text-coral" data-id="element-1689" />
          <h2 className="text-sm font-semibold text-navy" data-id="element-1690">
            Condizioni del contratto
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-1691">
          <div className="rounded-lg border border-border p-3" data-id="element-1692">
            <span className="flex items-center gap-1.5 text-[10px] uppercase tracking-wider font-semibold text-muted-foreground" data-id="element-1693">
              <Tag size={11} data-id="element-1694" />
              Piano
            </span>
            <span className="block text-sm font-semibold text-navy mt-1" data-id="element-1695">
              {contract.plan}
            </span>
          </div>
          <div className="rounded-lg border border-border p-3" data-id="element-1696">
            <span className="flex items-center gap-1.5 text-[10px] uppercase tracking-wider font-semibold text-muted-foreground" data-id="element-1697">
              <Calendar size={11} data-id="element-1698" />
              Scadenza
            </span>
            <span className="block text-sm font-semibold text-navy mt-1" data-id="element-1699">
              {contract.expiry}
            </span>
          </div>
          <div className="rounded-lg border border-border p-3" data-id="element-1700">
            <span className="flex items-center gap-1.5 text-[10px] uppercase tracking-wider font-semibold text-muted-foreground" data-id="element-1701">
              <Wallet size={11} data-id="element-1702" />
              Prezzo / pulizia
            </span>
            <span className="block text-sm font-semibold text-navy mt-1" data-id="element-1703">
              €{contract.pricePerClean}
            </span>
          </div>
          <div className="rounded-lg border border-border p-3" data-id="element-1704">
            <span className="flex items-center gap-1.5 text-[10px] uppercase tracking-wider font-semibold text-muted-foreground" data-id="element-1705">
              <FileText size={11} data-id="element-1706" />
              Valore contratto
            </span>
            <span className="block text-sm font-semibold text-navy mt-1" data-id="element-1707">
              €{contractValue}
            </span>
          </div>
        </div>
      </div>

      {/* Progress */}
      {apartment.cleaningsTotal > 0 && <div className="bg-white border border-border rounded-xl p-4 lg:p-5 mb-6" data-id="element-1708">
          <div className="flex items-center justify-between mb-2" data-id="element-1709">
            <h2 className="text-sm font-semibold text-navy flex items-center gap-2" data-id="element-1710">
              <Clock size={16} className="text-coral" data-id="element-1711" />
              Avanzamento pulizie
            </h2>
            <span className="text-sm font-semibold text-navy" data-id="element-1712">
              {apartment.cleaningsDone}/{apartment.cleaningsTotal}
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2 mb-2" data-id="element-1713">
            <div className="bg-coral h-2 rounded-full transition-all duration-300" style={{
          width: `${pct}%`
        }} data-id="element-1714" />
          </div>
          <p className="text-xs text-muted-foreground" data-id="element-1715">
            {remaining} pulizie ancora disponibili nel pacchetto attivo.
          </p>
        </div>}

      {/* Earnings */}
      <div className="bg-white border border-border rounded-xl p-4 lg:p-5" data-id="element-1716">
        <div className="flex items-center gap-2 mb-4" data-id="element-1717">
          <Wallet size={16} className="text-teal-deep" data-id="element-1718" />
          <h2 className="text-sm font-semibold text-navy" data-id="element-1719">Guadagni maturati</h2>
        </div>
        <div className="grid grid-cols-2 gap-3" data-id="element-1720">
          <div className="rounded-lg bg-navy/5 p-4" data-id="element-1721">
            <div className="text-2xl font-bold text-navy" data-id="element-1722">€{totalEarnings}</div>
            <div className="text-xs text-muted-foreground mt-0.5" data-id="element-1723">
              Totale generato
            </div>
          </div>
          <div className="rounded-lg bg-coral/5 p-4" data-id="element-1724">
            <div className="text-2xl font-bold text-coral" data-id="element-1725">
              €
              {contractValue - totalEarnings > 0 ? contractValue - totalEarnings : 0}
            </div>
            <div className="text-xs text-muted-foreground mt-0.5" data-id="element-1726">
              Potenziale residuo
            </div>
          </div>
        </div>
      </div>
    </MobileLayout>;
}